import { Observable } from 'rxjs';

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { API_OPTIONS, ApiOptions } from './api-options';
import { API_ENVIRONMENT, API_BACKENDS } from './tokens';

/**
 * @public
 */
export class BackendHttpInterceptor implements HttpInterceptor {
  private apiEnvironment = inject(API_ENVIRONMENT);
  private apiBackends = inject(API_BACKENDS);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const options: ApiOptions = req.context.get(API_OPTIONS);
    return next.handle(options.addBackendUrl(req, this.apiBackends[this.apiEnvironment]));
  }
}

/**
 * @public
 */
export abstract class HeaderHttpInterceptor implements HttpInterceptor {
  private apiEnvironment = inject(API_ENVIRONMENT);
  private apiBackends = inject(API_BACKENDS);
  abstract getLanguage(): string;
  abstract getApiKey(): string;
  abstract getAuthorizationHeader(): string;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const options: ApiOptions = req.context.get(API_OPTIONS);
    return next.handle(
      options.addHeaders(req, this.apiBackends[this.apiEnvironment], this.getAuthorizationHeader(), this.getLanguage(), this.getApiKey()),
    );
  }
}
